export const getTimeParam = (tiempo, param) =>{
    let aux = tiempo.split(":") 
    //console.log(aux)   
    if(param === "s"){
        return parseInt(aux[0])*60+parseInt(aux[1])*60+parseInt(aux[2]);
    }else if(param==="m"){
        return parseInt(aux[0])*60+parseInt(aux[1])
    }else{
        return parseInt(aux[0]);
    }
    
}